import { DocumentSigningStatusEnumType } from '__generated__/graphql';

export default function documentSigningStatusToReadable(status: DocumentSigningStatusEnumType): {
  label: string;
  color: string;
} {
  switch (status) {
    case DocumentSigningStatusEnumType.NotSent:
      return {
        label: 'Not Sent',
        color: 'gray',
      };
    case DocumentSigningStatusEnumType.Sent:
      return {
        label: 'Sent',
        color: 'amber',
      };
    case DocumentSigningStatusEnumType.Viewed:
      return {
        label: 'Viewed',
        color: 'amber',
      };
    case DocumentSigningStatusEnumType.Signed:
      return {
        label: 'Signed',
        color: 'green',
      };
    case DocumentSigningStatusEnumType.Declined:
      return {
        label: 'Declined',
        color: 'red',
      };
    case DocumentSigningStatusEnumType.Expired:
      return {
        label: 'Expired',
        color: 'red',
      };
    case DocumentSigningStatusEnumType.Error:
      return {
        label: 'Error',
        color: 'red',
      };
    default:
      return {
        label: 'Unknown',
        color: 'gray',
      };
  }
}
